import { useEffect, useState } from 'react'
import { makeStyles } from '@mui/styles'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import InputBase from '@mui/material/InputBase'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import MenuIcon from '@mui/icons-material/Menu'
import { withStyles } from '@mui/styles'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'
import { useTranslation } from 'react-i18next'
import { changeLanguagePref } from '../utilities/language'
import i18n from '../utilities/i18n'
import { userLogout } from '../actions/userActions'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { showAlertSnackbar } from '../reducers/sliceReducer'
import { sortKeys } from '../utilities/common'
import {
  getOrdersAndSalary,
  getTeamOrdersAndSalary
} from '../actions/driverActions'
import {
  getCurrentPaymentPeriod,
  handleDetails
} from '../actions/driverActionsUS'
import { getIsTeamData } from '../utilities/team'
import IncomeCompleteTable from './IncomeCompleteTable'
import FullscreenLoading from './FullscreenLoading'
import PopUp from './Popup'
import dayjs from 'dayjs'

const useStyles = makeStyles(theme => ({
  root: {
    width: 315,
    marginTop: 22,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  menuBurger: {
    height: 21.75,
    width: 29
  },
  overviewTitle: {
    height: 29,
    color: '#101820',
    fontSize: 24,
    fontWeight: 'bold',
    letterSpacing: 0,
    marginTop: 29
  },
  overViewUsername: {
    height: 21,
    color: '#101820',
    fontSize: 18,
    letterSpacing: 0,
    marginTop: 13
  },
  selectPeriod: {
    marginTop: 13,
    width: 313
  },
  selectedMenuItem: {
    backgroundColor: '#FFE5CD !important'
  },
  selectedMenuItemHistory: {
    backgroundColor: 'white !important'
  },
  overviewContent: {
    marginTop: 20,
    width: 313
  },
  overViewDate: {
    height: 21,
    opacity: 0.5,
    color: '#101820',
    fontSize: 18,
    fontWeight: 'bold',
    letterSpacing: 0
  },
  incomeTitle: {
    color: '#F68D2E',
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0
  },
  incomeAmount: {
    color: '#F68D2E',
    fontSize: 40,
    fontWeight: 600,
    letterSpacing: 0
  },
  overviewTable: {
    marginTop: 22,
    borderTop: '3px solid #0D1923'
  },
  overviewTableRow: {
    backgroundColor: 'rgba(235,236,239,0.8)',
    padding: 11
  },
  overviewTableDetail: {
    display: 'flex',
    justifyContent: 'space-between',
    width: 290,
    paddingBottom: 7
  },
  overviewTableDescription: {
    height: 36,
    width: 313,
    color: '#686868',
    fontSize: 12,
    letterSpacing: 0,
    marginTop: 10
  },
  viewDetails: {
    marginTop: 32,
    marginLeft: 160,
    display: 'flex',
    alignItems: 'center'
  },
  viewDetailsText: {
    width: 129,
    color: '#F68D2E',
    fontSize: 18,
    fontWeight: 500,
    letterSpacing: 0,
    textAlign: 'center'
  },
  drawerStyle: {
    height: '90vh',
    opacity: 0.9,
    backgroundColor: '#101820',
    width: 215,
    padding: 30,
    display: 'flex',
    flexDirection: 'column'
  },
  menuTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    letterSpacing: 0,
    marginTop: 40
  },
  languageTitle: {
    height: 21,
    width: 82,
    opacity: 0.2,
    color: '#FFFFFF',
    fontSize: 18,
    fontWeight: 500,
    letterSpacing: 0
  },
  languageSelected: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 'bold',
    letterSpacing: 0,
    borderBottom: '1px solid #FFFFFF',
    width: 'fit-content',
    marginTop: 24
  },
  language: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 'bold',
    letterSpacing: 0,
    marginTop: 24
  },
  dateDownload: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}))
const BootstrapInput = withStyles(theme => ({
  root: {
    '& .MuiInputBase-input': {
      height: 23,
      width: 313,
      color: '#F68D2E',
      fontSize: 16,
      fontWeight: 500,
      letterSpacing: 0,
      borderRadius: 7,
      backgroundColor: '#FFE5CD',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      paddingLeft: 13.5,
      paddingTop: 11,
      paddingRight: 88.5,
      paddingBottom: 11,
      '&:focus': {
        borderRadius: 4,
        boxShadow: '0 0 10px #fff'
      }
    },
    '& .MuiSelect-icon': {
      color: '#F68D2E'
    }
  }
}))(InputBase)

const isCA = process.env.REACT_APP_COUNTRY === 'CA'
const isUS = process.env.REACT_APP_COUNTRY === 'US'

function IncomeOverview(props) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('incomeOverview')

  const currentDateRange = useSelector(
    state => state.driverUSReducer.getSettlementTimeList
  )
  const currentPayment = useSelector(
    state => state.driverUSReducer.getCurrentPayment
  )

  const [period, setPeriod] = useState(0)
  const [showDrawer, setShowDrawer] = useState(false)
  const [username, setUsername] = useState('')
  const [subjectId, setSubjectId] = useState('')
  const [currentStart, setCurrentStart] = useState('')
  const [currentEnd, setCurrentEnd] = useState('')
  const [currentStartTime, setCurrentStartTime] = useState(0)
  const [currentEndTime, setCurrentEndTime] = useState(0)
  const [lastStart, setLastStart] = useState('')
  const [lastEnd, setLastEnd] = useState('')
  const [loading, setLoading] = useState(false)
  const [style, setStyle] = useState(2)
  const [popupOpen, setPopupOpen] = useState(false)
  const [isTeamLeader, setIsTeamLeader] = useState(false)
  const [isTeamData, setIsTeamData] = useState(getIsTeamData())
  const [showIncome, setShowIncome] = useState(false)
  const [completed, setCompleted] = useState()
  // const [incompleted, setIncompleted] = useState();
  const [overweightOrders, setOverweightOrders] = useState()
  const [overweightAmount, setOverweightAmount] = useState()
  const [allowance, setAllowance] = useState()
  const [amount, setAmount] = useState()
  const [salaryInfo, setSalaryInfo] = useState({})

  async function viewDetails() {
    if (isCA) {
      window.localStorage.setItem('current-start-now', currentStart)
      window.localStorage.setItem('current-end-now', currentEnd)
      window.localStorage.setItem('current-start-time-now', currentStartTime)
      window.localStorage.setItem('current-end-time-now', currentEndTime)
      history.push('/driverMobile/deliveryStatements')
    }
    if (isUS) {
      try {
        window.localStorage.setItem(
          'current-start-end',
          Object.keys(currentDateRange)[0]
        )
        let promises = {}
        await Promise.all(
          currentDateRange[Object.keys(currentDateRange)[0]].days.map(
            async (day, key) => {
              await dispatch(
                getCurrentPaymentPeriod(subjectId, day.start, day.end)
              ).then(res => {
                promises[day.date] = res
              })
            }
          )
        )
        await dispatch(handleDetails(sortKeys(promises)))
        await history.push('/driverMobile/deliveryStatements')
      } catch {
        dispatch(showAlertSnackbar({ message: t('contact_it'), type: 'error' }))
      }
    }
  }

  useEffect(() => {
    window.localStorage.setItem('period', period)
    if (period === 2) history.push('/driverMobile/incomeStatements')
  }, [history, period])
  useEffect(() => {
    const username = window.localStorage.getItem('username')
    if (username) setUsername(username)
  }, [])
  useEffect(() => {
    const subjectId = window.localStorage.getItem('subject_id')
    if (subjectId) setSubjectId(window.localStorage.getItem('subject_id'))
  }, [])
  useEffect(() => {
    if (isCA) {
      let currentStart = ''
      let currentStartTime = ''
      let currentEnd = ''
      let currentEndTime = ''
      let lastStart = ''
      let lastStartTime = ''
      let lastEnd = ''
      let lastEndTime = ''

      const current = dayjs()
      if (current.date() <= 15) {
        currentStart = current.date(1)
        currentEnd = current
        lastStart = current.subtract(1, 'month').date(16)
        lastEnd = current.subtract(1, 'month').endOf('month')
      } else {
        currentStart = current.date(16)
        currentEnd = current
        lastStart = current.date(1)
        lastEnd = current.date(15)
      }

      // Prepare backend values, add 1 day for end times because database tables are named that way
      currentStartTime = currentStart.format('YYYYMMDD')
      currentEndTime = currentEnd.add(1, 'day').format('YYYYMMDD')
      lastStartTime = lastStart.format('YYYYMMDD')
      lastEndTime = lastEnd.add(1, 'day').format('YYYYMMDD')

      // Prepare display values
      currentStart = currentStart.format('MMM D')
      currentEnd = currentEnd.format('MMM D')
      lastStart = lastStart.format('MMM D')
      lastEnd = lastEnd.format('MMM D')

      setCurrentStart(currentStart)
      setCurrentStartTime(currentStartTime)
      setCurrentEnd(currentEnd)
      setCurrentEndTime(currentEndTime)

      setLastStart(lastStart)
      setLastEnd(lastEnd)
      window.localStorage.setItem('lastStart', lastStart)
      window.localStorage.setItem('lastEnd', lastEnd)
      window.localStorage.setItem('lastStartTime', lastStartTime)
      window.localStorage.setItem('lastEndTime', lastEndTime)

      if (props.open) {
        setLoading(true)
        const getOrdersAndSalaryFunc = isTeamData
          ? getTeamOrdersAndSalary
          : getOrdersAndSalary
        if (period === 0) {
          if (currentStartTime && currentEndTime) {
            dispatch(getOrdersAndSalaryFunc(currentStartTime, currentEndTime))
              .then(res => {
                const driver = res.driverinfo[0]
                const data = res.data[0]
                window.localStorage.setItem('email', driver.email)
                const isTeamLeader = Boolean(driver.team_leader)
                const showIncome = isTeamData ? true : driver.show_salary
                setIsTeamLeader(isTeamLeader)
                setShowIncome(showIncome)
                setAmount(data.amt)
                setCompleted(data.completed)
                // setIncompleted(data.incompleted);
                setOverweightOrders(data.overweight)
                setOverweightAmount(data.owamt)
                setAllowance(data.amt_adj)
                setLoading(false)
              })
              .catch(err => {
                setLoading(false)
              })
          }
        } else if (period === 1) {
          if (lastStartTime && lastEndTime) {
            dispatch(getOrdersAndSalaryFunc(lastStartTime, lastEndTime))
              .then(res => {
                window.localStorage.setItem('email', res.driverinfo[0].email)
                setLoading(false)
                setSalaryInfo(res.data)
              })
              .catch(err => {
                setLoading(false)
              })
          }
        }
      }
    }
  }, [props.open, period, isTeamData, dispatch])

  return (
    <div>
      <div className={classes.root}>
        <div>
          <MenuIcon fontSize='large' onClick={() => setShowDrawer(true)} />
        </div>
        <div className={classes.overviewTitle}>
          {isUS ? t('title_us') : isTeamData ? t('team_overview') : t('title')}
        </div>
        <div className={classes.overViewUsername}>
          {isUS ? subjectId + '.' + username : username}
        </div>
        <div className={classes.selectPeriod}>
          <Select
            fullWidth
            value={period}
            onChange={e => setPeriod(e.target.value)}
            input={<BootstrapInput />}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left'
              }
            }}>
            <MenuItem
              value={0}
              classes={{ selected: classes.selectedMenuItem }}
              style={{
                height: 44,
                width: 295,
                borderRadius: 7,
                margin: 10
              }}>
              {isUS ? t('current_payment_us') : t('current_payment')}
            </MenuItem>
            {isCA && (
              <MenuItem
                value={1}
                classes={{ selected: classes.selectedMenuItem }}
                style={{
                  height: 44,
                  width: 295,
                  borderRadius: 7,
                  margin: 10
                }}>
                {t('last_payment')}
              </MenuItem>
            )}
            <MenuItem
              value={2}
              classes={{ selected: classes.selectedMenuItemHistory }}
              style={{
                height: 44,
                width: 295,
                margin: 10,
                paddingTop: 10,
                borderTop: '1px solid rgba(16,24,32,0.2)'
              }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {isCA && <MonetizationOnIcon style={{ marginRight: 12 }} />}
                <div style={{ marginRight: 5 }}>
                  {isUS ? t('history_income_us') : t('history_income')}
                </div>
                <ArrowRightAltIcon />
              </div>
            </MenuItem>
          </Select>
        </div>
        <div className={classes.overviewContent}>
          {period === 0 && (
            <div className={classes.overViewDate}>
              {isUS
                ? Object.keys(currentDateRange)[0]
                : `${currentStart} - ${currentEnd}`}
            </div>
          )}
          {period === 1 && (
            <div className={classes.dateDownload}>
              <div className={classes.overViewDate}>
                {lastStart} - {lastEnd}
              </div>
              <div>
                <Button
                  style={{
                    backgroundColor: 'white',
                    height: 25,
                    border: '2px solid rgba(16,24,32,0.3)',
                    borderRadius: 12.5,
                    color: '#101820',
                    fontSize: 12,
                    fontWeight: 'bold',
                    letterSpacing: 0,
                    textAlign: 'center',
                    paddingTop: 6,
                    paddingBottom: 6,
                    paddingLeft: 9,
                    paddingRight: 9
                  }}>
                  <span
                    style={{ textAlign: 'center' }}
                    onClick={() => {
                      setStyle(style)
                      setPopupOpen(true)
                    }}>
                    {t('download')}
                  </span>
                </Button>
              </div>
            </div>
          )}
          {period === 0 && (
            <div>
              {isUS && (
                <div
                  className={classes.overviewTable}
                  style={{ border: 'none' }}>
                  <div
                    className={classes.overviewTableRow}
                    style={{ backgroundColor: '#FFE5CD4D' }}>
                    <div
                      className={classes.overviewTableDetail}
                      style={{ borderBottom: '3px solid #0D1923' }}>
                      <div>{t('completed_orders')}</div>
                      <div>{currentPayment?.complete}</div>
                    </div>
                  </div>
                  <div
                    className={classes.overviewTableRow}
                    style={{ backgroundColor: '#FFE5CD4D' }}>
                    <div
                      className={classes.overviewTableDetail}
                      style={{ borderBottom: '1px solid #8A8B8A' }}>
                      <div>{t('smaller')}</div>
                      <div>{currentPayment?.lt}</div>
                    </div>
                  </div>
                  <div
                    className={classes.overviewTableRow}
                    style={{ backgroundColor: '#FFE5CD4D' }}>
                    <div
                      className={classes.overviewTableDetail}
                      style={{ borderBottom: '1px solid #8A8B8A' }}>
                      <div>{t('between')}</div>
                      <div>{currentPayment?.between}</div>
                    </div>
                  </div>
                  <div
                    className={classes.overviewTableRow}
                    style={{ backgroundColor: '#FFE5CD4D' }}>
                    <div className={classes.overviewTableDetail}>
                      <div>{t('larger')}</div>
                      <div>{currentPayment?.gt}</div>
                    </div>
                  </div>
                </div>
              )}
              {isUS && (
                <div
                  className={classes.overviewTableRow}
                  style={{ marginTop: 20 }}>
                  <div className={classes.overviewTableDetail}>
                    <div>{t('overdue')}</div>
                    <div>{currentPayment?.overdue}</div>
                  </div>
                </div>
              )}
              {isCA && showIncome && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    justifyContent: 'space-between',
                    marginTop: 33
                  }}>
                  <span className={classes.incomeTitle}>
                    {t('estimated_income')}
                  </span>
                  <span className={classes.incomeAmount}>
                    {amount ? `$${Number(amount).toFixed(2)}` : '$0'}
                  </span>
                </div>
              )}
              {isCA && (
                <div className={classes.overviewTable}>
                  <div className={classes.overviewTableRow}>
                    <div
                      className={classes.overviewTableDetail}
                      style={{ borderBottom: '1px solid #8A8B8A' }}>
                      <div>{t('completed_orders')}</div>
                      <div>{completed}</div>
                    </div>
                  </div>
                  <div className={classes.overviewTableRow}>
                    <div
                      className={classes.overviewTableDetail}
                      style={{ borderBottom: '1px solid #8A8B8A' }}>
                      <div>{t('overweight_orders')}</div>
                      <div>{overweightOrders}</div>
                    </div>
                  </div>
                  <div className={classes.overviewTableRow}>
                    <div
                      className={classes.overviewTableDetail}
                      style={{ borderBottom: '1px solid #8A8B8A' }}>
                      <div>{t('overweight_amount')}</div>
                      <div>{overweightAmount}</div>
                    </div>
                  </div>
                  <div className={classes.overviewTableRow}>
                    <div className={classes.overviewTableDetail}>
                      <div>{t('allowance_deduction')}</div>
                      <div>{allowance}</div>
                    </div>
                  </div>
                </div>
              )}
              {isCA && (
                <div className={classes.overviewTableDescription}>
                  {t('notice')}
                </div>
              )}
              {isCA ? (
                <div className={classes.viewDetails} onClick={viewDetails}>
                  <div className={classes.viewDetailsText}>
                    {t('delivery_details')}
                  </div>
                  <ArrowRightAltIcon style={{ color: '#F68D2E' }} />
                </div>
              ) : (
                <div
                  className={classes.viewDetails}
                  onClick={viewDetails}
                  style={{ marginLeft: 140 }}>
                  <div
                    className={classes.viewDetailsText}
                    style={{ width: 200 }}>
                    {t('delivery_details_us')}
                  </div>
                  <ArrowRightAltIcon style={{ color: '#F68D2E' }} />
                </div>
              )}
            </div>
          )}
          {period === 1 && (
            <IncomeCompleteTable
              type='income-overview'
              showIncome={showIncome}
              salaryInfo={salaryInfo}
            />
          )}
        </div>
      </div>
      <Drawer
        anchor='left'
        open={showDrawer}
        onClose={() => setShowDrawer(false)}>
        <Box className={classes.drawerStyle}>
          <div>
            <MenuIcon fontSize='large' style={{ color: '#F68D2E' }} />
          </div>
          <div
            className={classes.menuTitle}
            onClick={() => {
              setShowDrawer(false)
              setIsTeamData(false)
              window.localStorage.setItem('overview', 'driver')
            }}
            style={!isTeamData ? { color: '#EA882D' } : { color: 'white' }}>
            {t('title')}
          </div>
          {isTeamLeader && (
            <div
              className={classes.menuTitle}
              onClick={() => {
                setShowDrawer(false)
                setIsTeamData(true)
                window.localStorage.setItem('overview', 'team')
              }}
              style={isTeamData ? { color: '#EA882D' } : { color: 'white' }}>
              {t('team_overview')}
            </div>
          )}
          <Box flex={1} />
          <div className={classes.languageTitle}>{t('language')}</div>
          {/* <div 
              className={classes.language}
              style={
                  i18n.language==='cn' ?
                  {
                      borderBottom: '1px solid #FFFFFF',
                      width: 'fit-content'
                  }:{
                      border: 'none'
                  }
              }
              onClick={() => changeLanguagePref(i18n, "cn")}>
              中文
          </div> */}
          <div
            className={classes.language}
            onClick={() => changeLanguagePref(i18n, 'en')}
            style={
              i18n.language === 'en'
                ? {
                    borderBottom: '1px solid #FFFFFF',
                    width: 'fit-content'
                  }
                : {
                    border: 'none'
                  }
            }>
            English
          </div>
          {/* <div 
            className={classes.language}
            style={
                i18n.language==='fr' ?
                {
                    borderBottom: '1px solid #FFFFFF',
                    width: 'fit-content'
                } : {
                    border: 'none'
                }
            }
            onClick={() => changeLanguagePref(i18n, "fr")}>
            Français
        </div> */}
        </Box>
        <Divider />
        <div
          style={{
            height: '10vh',
            opacity: 0.9,
            backgroundColor: '#101820',
            width: 215,
            padding: 30
          }}>
          <div
            style={{
              color: '#FFFFFF',
              fontSize: 16,
              fontWeight: 'bold',
              letterSpacing: 0
            }}
            onClick={() => userLogout(true)}>
            {t('log_out')}
          </div>
        </div>
      </Drawer>
      <FullscreenLoading open={loading} />
      <PopUp
        style={style}
        open={popupOpen}
        handlePopupClose={() => setPopupOpen(false)}
        type='income'
        timeStart={window.localStorage.getItem('lastStartTime')}
        timeEnd={window.localStorage.getItem('lastEndTime')}
      />
    </div>
  )
}

export default IncomeOverview
